











































import { Component, Vue } from 'vue-property-decorator';

@Component({})
export default class EksikIcraDaireleri extends Vue {
  kayitlar: any[] = [];
  yukleniyor: boolean = false;
  hata: string = "";

  basliklar = [
    { text: "İcra dairesi adı", value: "icra_dairesi_isim" },
    { text: "UYAP birim kimliği", value: "uyap_birim_id" },
    { text: "Deneme sayısı", value: "deneme_sayisi" },
    { text: "Son görülme", value: "updated_at" },
  ];

  created() {
    this.yukle();
  }

  async yukle() {
    this.yukleniyor = true;
    this.hata = "";
    try {
      const yanit = await this.$http.get(this.$store.state.icwApiUrl + 'admin/eksik-icra-daireleri');
      this.kayitlar = Array.isArray(yanit.data) ? yanit.data : [];
    } catch (e) {
      this.hata = this.hataMesaji(e, "Kuyruk okunamadı.");
    } finally {
      this.yukleniyor = false;
    }
  }

  tarih(deger: any): string {
    if (!deger) return "—";
    // Mongo tarihi {$date:...} sarmalayicisiyla da gelebiliyor.
    const ham = typeof deger === 'object' ? (deger.$date ?? deger.date ?? '') : deger;
    const d = new Date(ham);
    return isNaN(d.getTime()) ? String(ham) : d.toLocaleString('tr-TR');
  }

  /** Axios hatasi, JSON hatasi veya duz Error olabilir; okunur tek mesaja indirger. */
  hataMesaji(e: any, varsayilan: string): string {
    const sunucu = e && e.response && e.response.data ? e.response.data.message : null;
    return sunucu || (e && e.message) || varsayilan;
  }
}
